class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    const _this = this;
    const discountApplyBtn = document.getElementById('discount-code-apply');
    if (discountApplyBtn !== null) {
      discountApplyBtn.addEventListener('click', function () {
        const discount_input = document.getElementById('discount-code-input').value;

        if (discount_input !== '') {
          _this.applyDiscountCode(discount_input);
        }
      });
    }

    const discountRemoveBtn = document.getElementById('discount-code-remove');
    if (discountRemoveBtn !== null) {
      discountRemoveBtn.addEventListener('click', function () {
          _this.applyDiscountCode('remove');
      });
    }

    this.initGiftNotes();
  }

  initGiftNotes() {
    const _this = this;
    const giftNoteContainers = document.getElementsByClassName('gift-note-item-container');

    if (giftNoteContainers.length > 0) {
      for (let i = 0; i < giftNoteContainers.length; i++) {
        let giftNoteContainer = giftNoteContainers[i];

        let itemKey = giftNoteContainer.dataset.item_key;
        let itemLine = giftNoteContainer.dataset.item_line;
        let giftNoteBtn = document.getElementById('gift-note-apply-' + itemKey);

        giftNoteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          let giftNoteInput = document.getElementById('gift-note-input-' + itemKey)
          let obj = '{';
          obj = obj + '"Gift Note": ' + '"' + giftNoteInput.value + '"';
          obj = obj + '}';

          const propsObj = JSON.parse(obj);

          _this.saveGiftNote(itemLine, propsObj);
        });
      }

      $('.gift-collapse').on('click', function(){
        const targetsParent = $(this).parent('.gift-note-item-container');
        const targetDataID = targetsParent.attr('data-item_id');
        const theTextField = $('#'+targetDataID);

        if (!targetsParent.hasClass('collapse')) {
          targetsParent.addClass('collapse');
          theTextField.show();
        } else {
          targetsParent.removeClass('collapse');
          theTextField.hide();
        }
      });

      $('.gift-note-input').each(function() {
        $(this).keyup(function() {
          var len = $(this).val().length;

          if (len >= 500) {
            $(this).val($(this).val().substring(0, 500));
          } else {
            $(this).siblings('.counter-note-flex').find('span').text(len);
          }

          if ($(this).val() != '' && $(this).val() != 0) {
            $(this).siblings('.counter-note-flex').find('.note-button').attr('disabled', false);
          } else {
            $(this).siblings('.counter-note-flex').find('.note-button').attr('disabled', true);
          }
        });
      });
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }

            this.initializeSlider();
            this.initGiftNotes();
          }
        })
        .catch((e) => {
          this.initGiftNotes();
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  // Function to initialize the Slick slider
  initializeSlider() {
    $('.cart-drawer-collection-slider').each(function() {
      $(this).slick({
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '0px',
        slidesToScroll: 1,
        prevArrow: $('.slider-drawer-button--prev'),  // Target the custom previous button
        nextArrow: $('.slider-drawer-button--next'),  // Target the custom next button
      });
    });

    // Ensure the next and previous buttons work correctly
    $('.slider-drawer-button--prev').on('click', function() {
      $('.cart-drawer-collection-slider').slick('slickPrev');
    });

    $('.slider-drawer-button--next').on('click', function() {
      $('.cart-drawer-collection-slider').slick('slickNext');
    });

    $('.add-to-cart-btn').on('click', function(e) {
      e.preventDefault(); // Prevent default form submission
      var productId = $(this).data('product-id'); // Get the product ID
      var form = $('#add-to-cart-form-' + productId);
      var variantId = form.find('input[name="id"]').val();
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: variantId },
        dataType: 'json',
        success: function(response) {
          updateCartItems();
          updateCartBubble();
        },
        error: function(xhr, status, error) {
          // Handle error
          console.log('Error adding product to cart:', error);
          alert('Failed to add product to cart.');
        }
      });
    });
  
    function updateCartItems() {
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(data) {
          var updatedCartItems = $(data).find('#CartDrawer-CartItems');
          
          $('#CartDrawer-CartItems').html(updatedCartItems.html());
  
          var updatedTotals = $(data).find('.totals__total-value').html();
          $('.totals__total-value').html(updatedTotals);
        },
        error: function(xhr, status, error) {
          console.log('Error fetching updated cart items:', error);
        }
      });
    }

    function updateCartBubble() {
      $.ajax({
        type: 'GET',
        url: '/cart.js', // Fetch the cart JSON data
        dataType: 'json',
        success: function(cart) {
          var itemCount = cart.item_count;
          var cartBubbleHeader = $('#header-cart-count');
          var cartBubbleDrawer = $('.cart-count-bubble span');
          cartBubbleHeader.text(itemCount);
          cartBubbleDrawer.text(itemCount);
        },
        error: function(xhr, status, error) {
          console.log('Error updating cart bubble:', error);
        }
      });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    if (line === undefined) {
      return false;
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        const appliedDiscountCode = document.querySelector('[data-applied-discount]');
        if(appliedDiscountCode && appliedDiscountCode.dataset.appliedDiscount.includes('FRIENDS')) {          
          // Define which code to apply according to the cart total before discount
          const cartTotalPreDiscount = parsedState.items_subtotal_price;
          let friendCodeToApply = '';
          if (cartTotalPreDiscount >= 10000 && cartTotalPreDiscount < 50000) {
            friendCodeToApply = 'FRIENDS';
          } else if (cartTotalPreDiscount >= 50000 && cartTotalPreDiscount < 100000) {
            friendCodeToApply = 'FRIENDS-2';
          } else if (cartTotalPreDiscount >= 100000 && cartTotalPreDiscount < 300000) {
            friendCodeToApply = 'FRIENDS-3';
          } else if (cartTotalPreDiscount >= 300000) {
            friendCodeToApply = 'FRIENDS-4';
          }

          if(friendCodeToApply != '') {
            this.applyDiscountCode(friendCodeToApply);            
          }                      
        }
        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        this.initializeSlider();
        this.initGiftNotes();
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this.initGiftNotes();
      });
  }

  applyDiscountCode(code) {
    this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.remove('hidden'));
    const cartTotalPreDiscount = parseFloat(document.querySelector('.totals__total-value').textContent.replace('$', '').replace(/,/g, ''));
    let codeLowercase = code.toLowerCase();    

    if(codeLowercase.includes('friends')) {      
      if (cartTotalPreDiscount >= 100 && cartTotalPreDiscount < 500) {
        code = 'FRIENDS';        
      } else if (cartTotalPreDiscount >= 500 && cartTotalPreDiscount < 1000) {
        code = 'FRIENDS-2';        
      } else if (cartTotalPreDiscount >= 1000 && cartTotalPreDiscount < 3000) {
        code = 'FRIENDS-3';        
      } else if (cartTotalPreDiscount >= 3000) {
        code = 'FRIENDS-4';        
      }
    }    

    fetch(`/discount/${code}?redirect=/cart`)
        .then((response) => {
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
          this.getSectionsToRender().forEach((section) => {
            let sources = html.getElementById(section.id).querySelectorAll(section.selector);
            let destinations = document.getElementById(section.id).querySelectorAll(section.selector);

            if (sources.length > 0 && destinations.length > 0 && (sources.length === destinations.length)) {
              for (let i = 0; i < destinations.length; i++) {
                destinations[i].innerHTML = sources[i].innerHTML;
              }
            }
          });

          const _this = this;
          const discountRemoveBtn = document.getElementById('discount-code-remove');
          if (discountRemoveBtn !== null) {
            discountRemoveBtn.addEventListener('click', function () {
              _this.applyDiscountCode('remove');
            });
          }
        })
        .catch(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          this.initGiftNotes();
        });
  }

  saveGiftNote(line, props) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line: line,
      properties: props,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
              document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
                ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          // errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
          this.initGiftNotes();
        });
  }

  updateVariantId(line, variantId, itemProps) {
    this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.remove('hidden'));

    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          let properties = {};
          if(itemProps.length > 0){
            let propsArr = itemProps;
            let obj = '{';
            for (let l = 0; l < propsArr.length; l++) {
              obj = obj + '"' + propsArr[l][0] + '": ' + '"' + propsArr[l][1] + '",';
            }
            obj = obj.slice(0, -1);
            obj = obj + '}';
            
            const properties = JSON.parse(obj);
          }                    

          const body = JSON.stringify({
            id: variantId,
            properties,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          });

          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
              })
              .finally(() => {
                window.location.reload();
              });
        });


  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    // if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}